/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";

export const ProblemEntry = zod
  .object({
    code: zod.string().describe("Stable machine-readable problem code."),
    message: zod.string().describe("Human-readable problem message."),
    kind: zod.string().describe("Open-ended coarse problem category."),
    metadata: zod
      .record(zod.string(), zod.unknown())
      .describe("Problem-specific structured metadata."),
  })
  .describe("One deterministic problem in a Problem Details response.");

export type ProblemEntry = zod.input<typeof ProblemEntry>;
export type ProblemEntryOutput = zod.output<typeof ProblemEntry>;
